/**
 * NEONELLE HAUTE COUTURE RIGHT-SIDE CART DRAWER ENGINE (MATCHING /CART)
 */
(function() {
  'use strict';

  class NeonelleCartDrawer {
    constructor() {
      this.root = document.getElementById('NeonelleCartDrawer');
      this.backdrop = document.getElementById('NeonelleCartBackdrop');
      this.panel = document.getElementById('NeonelleCartPanel');
      this.closeBtn = document.getElementById('NeonelleDrawerClose');
      this.itemsList = document.getElementById('NeonelleCartItemsList');
      this.emptyState = document.getElementById('NeonelleCartEmptyState');
      this.footer = document.getElementById('NeonelleCartFooter');
      this.countEl = document.getElementById('NeonelleDrawerItemCount');
      this.rawSubtotalEl = document.getElementById('NeonelleCartRawSubtotal');
      this.subtotalEl = document.getElementById('NeonelleCartSubtotal');
      this.savingsRowEl = document.getElementById('NeonelleCartSavingsRow');
      this.savingsAmountEl = document.getElementById('NeonelleCartSavingsAmount');
      this.checkoutBtn = document.getElementById('NeonelleCheckoutBtn');
      this.isOpen = false;

      this.init();
    }

    init() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });

      // Bind all cart triggers across the page
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('#neonelle-cart-trigger, a[href="/cart"], .neonelle-cart-trigger');
        if (trigger) {
          e.preventDefault();
          this.open();
        }
      });

      window.addEventListener('neonelle:cart:open', () => this.open());
      window.addEventListener('neonelle:cart:refresh', () => this.refresh());
      document.addEventListener('cart:updated', () => this.refresh());
      document.addEventListener('cart:add', () => this.open());
      document.addEventListener('theme:cart:open', () => this.open());
    }

    async open() {
      if (!this.root) return;
      this.root.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
      await this.refresh();
    }

    close() {
      if (!this.root) return;
      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      this.isOpen = false;
    }

    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Error fetching cart:', err);
      }
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    render(cart) {
      // Update global navbar pills
      const pills = document.querySelectorAll('.neonelle-cart-pill, .neonelle-cart-badge');
      pills.forEach((p) => (p.textContent = cart.item_count));

      if (this.countEl) {
        this.countEl.textContent = `(${cart.item_count})`;
      }

      if (cart.item_count === 0) {
        if (this.itemsList) this.itemsList.style.display = 'none';
        if (this.emptyState) this.emptyState.style.display = 'flex';
        if (this.footer) this.footer.style.display = 'none';
        return;
      }

      if (this.itemsList) this.itemsList.style.display = 'flex';
      if (this.emptyState) this.emptyState.style.display = 'none';
      if (this.footer) this.footer.style.display = 'block';

      // 1. Calculate the true undiscounted subtotal (base price $95.95 * total qty)
      const rawSubtotalCents = cart.items.reduce((sum, item) => {
        const unitPrice = item.original_price || item.price || 9595;
        return sum + (unitPrice * item.quantity);
      }, 0);

      // 2. Determine Bundle Discount Tier
      let discountCode = '';
      let discountPercent = 0;
      let savingsCents = 0;
      let finalCents = rawSubtotalCents;

      if (cart.item_count >= 3) {
        discountCode = 'BUNDLE25';
        discountPercent = 0.25;
        savingsCents = Math.round(rawSubtotalCents * 0.25);
        finalCents = rawSubtotalCents - savingsCents; // $215.89
      } else if (cart.item_count >= 2) {
        discountCode = 'BUNDLE15';
        discountPercent = 0.15;
        savingsCents = Math.round(rawSubtotalCents * 0.15);
        finalCents = rawSubtotalCents - savingsCents; // $163.11
      }

      if (this.rawSubtotalEl) {
        if (discountPercent > 0) {
          this.rawSubtotalEl.innerHTML = `<s class="neonelle-price-strikethrough">${this.formatMoney(rawSubtotalCents)}</s>`;
        } else {
          this.rawSubtotalEl.textContent = this.formatMoney(rawSubtotalCents);
        }
      }

      if (discountPercent > 0) {
        if (this.savingsRowEl && this.savingsAmountEl) {
          this.savingsRowEl.style.display = 'flex';
          this.savingsAmountEl.textContent = `-${this.formatMoney(savingsCents)} (${discountPercent * 100}% OFF)`;
        }
        if (this.subtotalEl) {
          this.subtotalEl.textContent = this.formatMoney(finalCents);
        }
        if (this.checkoutBtn) {
          this.checkoutBtn.setAttribute('href', `/discount/${discountCode}?redirect=/checkout`);
        }
      } else {
        if (this.savingsRowEl) this.savingsRowEl.style.display = 'none';
        if (this.subtotalEl) {
          this.subtotalEl.textContent = this.formatMoney(rawSubtotalCents);
        }
        if (this.checkoutBtn) {
          this.checkoutBtn.setAttribute('href', '/checkout');
        }
      }

      // Render line items matching /cart minimal item
      if (!this.itemsList) return;
      this.itemsList.innerHTML = cart.items
        .map((item, idx) => {
          const lineIndex = idx + 1;
          const itemRawPrice = (item.original_price || item.price || 9595) * item.quantity;
          const itemDiscPrice = discountPercent > 0 ? Math.round(itemRawPrice * (1 - discountPercent)) : itemRawPrice;

          // Dynamic Variant & Multi-Pair Bundle Image Resolver
          const colorMap = window.NeonelleColorImages || {};
          let pairColors = [];
          if (item.properties) {
            ['Pair 1', 'Pair 2', 'Pair 3'].forEach(k => {
              if (item.properties[k]) {
                const val = item.properties[k].toLowerCase();
                if (val.includes('pink')) pairColors.push('pink');
                else if (val.includes('green')) pairColors.push('green');
                else if (val.includes('purple') || val.includes('violet')) pairColors.push('purple');
                else if (val.includes('cyan') || val.includes('blue')) pairColors.push('blue');
              }
            });
          }

          let imgMarkup = '';
          if (pairColors.length >= 2) {
            // Bundle Preview with chosen pair thumbnails
            const pairImgsHtml = pairColors.map((c, i) => {
              const src = colorMap[c] || item.image;
              return `<img src="${src}" class="multi-thumb thumb-${i+1}" alt="Pair ${i+1}" loading="lazy" />`;
            }).join('');
            imgMarkup = `<div class="neonelle-cart-multi-thumbs count-${pairColors.length}">${pairImgsHtml}</div>`;
          } else {
            // Solo 1-pair item: find chosen color
            let soloColor = '';
            if (item.properties && item.properties['Colorway']) {
              const cVal = item.properties['Colorway'].toLowerCase();
              if (cVal.includes('pink')) soloColor = 'pink';
              else if (cVal.includes('green')) soloColor = 'green';
              else if (cVal.includes('purple') || cVal.includes('violet')) soloColor = 'purple';
              else if (cVal.includes('cyan') || cVal.includes('blue')) soloColor = 'blue';
            }
            if (!soloColor && item.variant_title) {
              const vVal = item.variant_title.toLowerCase();
              if (vVal.includes('pink')) soloColor = 'pink';
              else if (vVal.includes('green')) soloColor = 'green';
              else if (vVal.includes('purple') || vVal.includes('violet')) soloColor = 'purple';
              else if (vVal.includes('cyan') || vVal.includes('blue')) soloColor = 'blue';
            }

            const chosenImg = (soloColor && colorMap[soloColor]) ? colorMap[soloColor] : (item.image || '');
            imgMarkup = `<img src="${chosenImg}" alt="${item.title}" class="neonelle-cart-item-img" loading="lazy" />`;
          }

          // Format clean properties metadata
          let metaParts = [];
          if (item.properties && Object.keys(item.properties).length > 0) {
            Object.entries(item.properties).forEach(([k, v]) => {
              if (!k.startsWith('_') && Boolean(v)) {
                metaParts.push(v);
              }
            });
          }

          let metaHtml = '';
          if (metaParts.length > 0) {
            metaHtml = `<div class="neonelle-cart-item-props">${metaParts.join(' &bull; ')}</div>`;
          }

          let priceDisplayHtml = '';
          if (discountPercent > 0) {
            priceDisplayHtml = `<s class="neonelle-item-raw-strikethrough">${this.formatMoney(itemRawPrice)}</s><span class="neonelle-item-discount-price">${this.formatMoney(itemDiscPrice)}</span>`;
          } else {
            priceDisplayHtml = `<span class="neonelle-item-discount-price">${this.formatMoney(itemRawPrice)}</span>`;
          }

          return `
            <div class="neonelle-cart-item" data-line="${lineIndex}" data-key="${item.key}">
              <div class="neonelle-cart-item-img-wrap">
                <a href="${item.url || '/products/out-past-midnight-led-cowboy-boots'}">
                  ${imgMarkup}
                </a>
              </div>
              <div class="neonelle-cart-item-details">
                <div class="neonelle-cart-item-top">
                  <div>
                    <h4 class="neonelle-cart-item-title">${item.product_title || item.title}</h4>
                    ${item.variant_title ? `<div class="neonelle-cart-item-variant">${item.variant_title}</div>` : ''}
                    ${metaHtml}
                  </div>
                  <div class="neonelle-cart-item-price-wrap">${priceDisplayHtml}</div>
                </div>

                <div class="neonelle-cart-item-bottom">
                  <div class="neonelle-minimal-stepper">
                    <button type="button" data-action="minus" data-line="${lineIndex}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
                    <span>${item.quantity}</span>
                    <button type="button" data-action="plus" data-line="${lineIndex}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">&plus;</button>
                  </div>
                  <button type="button" class="neonelle-minimal-remove" data-action="remove" data-line="${lineIndex}">
                    Remove
                  </button>
                </div>
              </div>
            </div>
          `;
        })
        .join('');

      // Bind quantity and remove actions
      this.bindItemActions();
    }

    bindItemActions() {
      if (!this.itemsList) return;

      this.itemsList.querySelectorAll('[data-action="minus"], [data-action="plus"]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          const line = e.currentTarget.getAttribute('data-line');
          const nextQty = parseInt(e.currentTarget.getAttribute('data-qty'), 10);
          await this.updateQuantity(line, nextQty);
        });
      });

      this.itemsList.querySelectorAll('[data-action="remove"]').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          const line = e.currentTarget.getAttribute('data-line');
          await this.updateQuantity(line, 0);
        });
      });
    }

    async updateQuantity(line, quantity) {
      try {
        if (this.itemsList) this.itemsList.style.opacity = '0.5';
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
        });
        const cart = await res.json();
        if (this.itemsList) this.itemsList.style.opacity = '1';
        this.render(cart);
      } catch (err) {
        if (this.itemsList) this.itemsList.style.opacity = '1';
        console.error('Error updating quantity:', err);
      }
    }
  }

  // Initialize and attach to global window
  document.addEventListener('DOMContentLoaded', () => {
    window.NeonelleCart = new NeonelleCartDrawer();
  });
})();
